module.exports = __webpack_public_path__ + "img/icon-meta.1b61a93a.svg";